import React from "react";
import Cards from "./Cards";
import "../Styles/Aside-courses.css";

const CoursesAside = ({ title, image, Cards }) => {
  return (
    <div className="aside-courses">
      <div className="card-left">
        <img src={image} className="card-top-img" />
      </div>

      <div className="aside-course-right">
        <h1 className="aside-course-heading">{title}</h1>
        <div className="aside-course-cards">
          {Cards && Cards.map((item,index) => {
                return (
                  <div key={index} className="aside-card-container">
                    <img src={item.icon} alt="icon" />
                    <div className="aside-card-content">
                      <h2>{item.heading}</h2>
                      <p>{item.content}</p>
                    </div>
                  </div>
                );
              })
          }
        </div>
      </div>
    </div>
  );
};

export default CoursesAside;
